import { Component, OnInit,Input } from '@angular/core';
import { Subscription} from 'rxjs';
import { DatePipe, DecimalPipe, PercentPipe } from '@angular/common';

import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { AssetMapService } from '../../services/assetmap.service';
import { SectionEditComponent } from '../section-edit/section-edit.component';

// JSON definitions of the edit forms
import AssetMapEdit from '../architecture-edit-assetmap.json';


@Component({
  selector: 'app-sl-asset-map',
  templateUrl: './sl-asset-map.component.html',
  styleUrls: ['./sl-asset-map.component.scss']
})
export class SlAssetMapComponent implements OnInit {

  @Input() showEditable=false;
  @Input() assetMapData;
  @Input() sAccount;
  @Input() sVersion;

  private assetMapsData$: Subscription;


  assetMapHasTotalEstateVals=false;

  constructor(
    public assetMapService: AssetMapService,
    public dialog: MatDialog,
    public decPipe: DecimalPipe,
    public pctPipe:PercentPipe,
    public datePipe:DatePipe,  
  ) { }

  ngOnInit(): void {

    // wire up the asset Map values
    this.assetMapsData$ = this.assetMapService.assetMap$.subscribe(
      (responsedata: any) => {
        if (responsedata != null) {
          if (responsedata.loading) {
          } else {

            // see if the data has any total estate vals
            // if it does then we should both values on the page
            // for all of the values

            responsedata["data"].forEach(x => {
              if (x["propertyname"].endsWith("_te")) {
                let val = x["propertytext"];
                if (x["propertytext"].trim() != "")
                  if (this.stringIsNumber(val)) {
                    if (+val !== 0) {
                      this.assetMapHasTotalEstateVals = true;
                    }
                  } else {
                    this.assetMapHasTotalEstateVals = true;
                  }
              }
            });

          }
        }
      }
    );
  }


  getAMapValue(prop,showte=true){    
    let val = this.assetMapData[prop]!=undefined ? this.assetMapData[prop]["propertytext"].trim() : "";  
    let val_te = this.assetMapData[prop+"_te"]!=undefined ? this.assetMapData[prop+"_te"]["propertytext"].trim() : "";
    
    val = this.fmtVal(val);
    val_te = this.fmtVal(val_te);

    if(this.assetMapHasTotalEstateVals && showte){
      if(val=="" && val_te==""){
        return "";
      } else {
        return (val==""?"?":val) + " / " + (val_te==""?"?":val_te);
      }      
    } else {
      return (val==""?"?":val)
    }
  }

  getAMapTotalValue(prop,sumofprops,showte=true){
    // if the value is specified then use it, otherwise add up the list
    let val = this.assetMapData[prop]!=undefined ? this.assetMapData[prop]["propertytext"].trim() : "";  
    let val_te = this.assetMapData[prop+"_te"]!=undefined ? this.assetMapData[prop+"_te"]["propertytext"].trim() : "";
    
    if(val==""){
      let t=0;
      // no value so add up the list
      sumofprops.forEach(x=> {
          let tmp = this.assetMapData[x]!=undefined ? this.assetMapData[x]["propertytext"].trim() : "";
          if(this.stringIsNumber(tmp)){
            t += (tmp-0);
            // stop any floating point issues
            t = +t.toFixed(6)
          }
      })
      val = t;
    }

    let allblank = true;
    if(val_te==""){
      let t=0;
      // no value so add up the list
      sumofprops.forEach(x=> {
          let tmp = this.assetMapData[x+"_te"]!=undefined ? this.assetMapData[x+"_te"]["propertytext"].trim() : "";
          if(tmp.trim()!="") allblank=false;
          if(this.stringIsNumber(tmp)){
            t += (tmp-0);
            // stop any floating point issues
            t = +t.toFixed(6)
          }
      })
      val_te = t;   
      if(allblank) val_te = "";
    }

    
    val = this.fmtVal(val);
    val_te = this.fmtVal(val_te);

    if(this.assetMapHasTotalEstateVals && showte){
      if(val=="" && val_te==""){
        return "";
      } else {
        return (val==""?"?":val) + " / " + (val_te==""?"?":val_te);
      }
    } else {
      return (val==""?"?":val)
    }

  }

  // helpers that just show the DXC val
  getAMapValueDXC(prop){
    return this.getAMapValue(prop,false)
  }

  getAMapTotalValueDXC(prop,sumofprops){
    return this.getAMapTotalValue(prop,sumofprops,false)
  }

  fmtVal(x:string){
    if(x==undefined || x == null) return "";

    x = ""+x;
    if(this.stringIsNumber(x)){
      // replicate the decimal places stored 
      let dplaces = 0;      
      if(x.indexOf(".")>0){
        dplaces = x.length - x.indexOf(".")-1;
      }
      return this.decPipe.transform(x, "1." + dplaces + "-" + dplaces)
    } else {
      return x;
    }
  }
  
  
  stringIsNumber(s) {
    return !isNaN(parseFloat(s)) && !isNaN(s - 0)
  }


  
  openAssetMapEdit(section){

    if(!this.showEditable) return false;
    
    let data = {
      sectionDef:AssetMapEdit,
      data: this.assetMapData,
      account: this.sAccount,
      versionid: this.sVersion,
      selectTab: section
    }

    let newdata = this.deepCopy(data);

    let dialogRef = this.dialog.open(SectionEditComponent, {
      height: '600px',
      width: '700px',
      data: newdata
    });

    dialogRef.afterClosed().subscribe(result => {

      if(result=="cancel"){
      
      } else if(result!=undefined){

        // save to the database
        this.updateAssetMapData(result)
        
      }
    })  
  }


  updateAssetMapData(data){
      
    // create a JSON array with just the changes
    let uData = [];
    Object.keys(data).forEach(x => {
      let drow = data[x];

      if(drow["newtext"]!==undefined){
      let newtext = (drow["newtext"] == null ? "" : drow["newtext"].trim());
      let oldtext = (drow["propertytext"] == null ? "" : drow["propertytext"].trim());

       if(newtext != oldtext){
        uData.push({
          "id":drow["id"],
          "accountid":drow["accountid"],
          "versionid":drow["versionid"],
          "propertyname":x,
          "propertytext": newtext
        })
      }
    }      
    });

    this.assetMapService.updateAssetMap(uData);
  }

    // deep copy of Object
    private deepCopy(obj) {
      return Object.keys(obj).reduce((v, d) => Object.assign(v, {
        [d]: obj[d]== null ? null : (obj[d].constructor === Object) ? this.deepCopy(obj[d]) : obj[d]
      }), {});
    }


}
